var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.btnFlag),expression:"btnFlag"}],staticClass:"th-back-top",on:{"click":_vm.backTop}},[_c('img',{staticClass:"bg-back2top2",attrs:{"src":require('../assets/img/backTop.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }